module.exports = __webpack_public_path__ + "img/btc.45b8e63f.png";